<template>
  <v-app>
    <Navbar v-if="!['Dashboard'].includes($route.name)"/>
    <v-main class="bg-image">
      <router-view></router-view>
    </v-main>
    <v-footer v-if="!['Dashboard'].includes($route.name)" color="primaryLight" padless>
      <v-container justify="center" class="primaryLight py-4 text-center white--text">
        {{ new Date().getFullYear() }} and beyond — Dr. Asmah Health Hub is powered by <a class="white--text" style="text-decoration: none; font-weight: bolder" target="__blank" href="https://synapsebn.com/">SynapseBN</a>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import Navbar from '@/components/Navbar';

export default {
  name: 'App',
  components : { Navbar },
  data() {
    return {

    }
  }
};
</script>
